import styled from 'styled-components';

export const Container = styled.div`
    /* height: 800px; */
    margin-top: 40px;
`;

export const ChartWrapper = styled.div`
`;